export default __webpack_public_path__ + "static/media/harmony-os.05bc017e.svg";